/* eslint-disable react/no-multi-comp */ // allow simple wrappers
import React from 'react'
import PropTypes from 'prop-types'
import styled, { cx } from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

import ListenToKeyboard from 'components/ListenToKeyboard'
import { ButtonWithDropdown } from 'shared/ui'
import DropdownSwitcher from '../DropdownSwitcher'

const ButtonDisableWrapper = ({ className, disabled, children, passRef }) => {
  return (
    <div className={cx(className, disabled ? 'disabled' : null)} ref={passRef}>
      {children}
    </div>
  )
}

const ButtonDisableWrapperStyled = styled(ButtonDisableWrapper)`
  transition: opacity 200ms ease-in-out;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`

/**
 * Serg: The code is morally wrong and disgusting but doing it properly will
 * take time and we need to ship this now. If you still see this in 3 months
 * (i.e. after March 2019), feel free to curse and shame me.
 */
class Button extends React.PureComponent {
  state = { dropdownOpen: false }

  closeDropdown = () => this.setState({ dropdownOpen: false })

  openDropdown = () => {
    const { disabled } = this.props
    if (!disabled) this.setState({ dropdownOpen: true })
  }

  toggleDropdown = () =>
    this.state.dropdownOpen ? this.closeDropdown() : this.openDropdown()

  handleDropdownClick = e => {
    const clickedOption = e.target.closest('.item[role="option"]')
    const isSnoozeOption =
      clickedOption && /snooze/.test(clickedOption.textContent)

    if (clickedOption && isSnoozeOption) return false

    return this.toggleDropdown()
  }

  handleSnoozeOptionClick = (snoozeUntil, evt) => {
    const { onSnoozeOptionClick } = this.props
    if (onSnoozeOptionClick) onSnoozeOptionClick(snoozeUntil, evt)
    this.closeDropdown()
  }

  handleButtonClick = () => {
    const {
      disabled,
      onSendClosedClick,
      onSendOpenClick,
      prefersOpen,
    } = this.props

    if (disabled) return

    if (prefersOpen) {
      onSendOpenClick()
    } else {
      onSendClosedClick()
    }

    this.closeDropdown()
  }

  containerRef = node => (this.container = node)

  findTrigger = () =>
    this.container && this.container.querySelector('.dropdown.button')

  render() {
    const {
      actionLabel,
      className,
      disabled,
      onSendOpenClick,
      onSendClosedClick,
      onSnoozeOptionClick,
      isOpen,
      prefersOpen,
    } = this.props
    const { dropdownOpen } = this.state

    return (
      <ButtonDisableWrapperStyled
        disabled={disabled}
        passRef={this.containerRef}
      >
        <ListenToKeyboard
          onEscape={this.closeDropdown}
          enabled={dropdownOpen}
        />
        <ButtonWithDropdown
          className={className}
          color={themeVars.groovyColorName}
          dropdown={
            <DropdownSwitcher
              actionLabel={actionLabel}
              isOpen={isOpen}
              onBlur={this.closeDropdown}
              onClick={this.handleDropdownClick}
              onSendClosedClick={onSendClosedClick}
              onSendOpenClick={onSendOpenClick}
              onSnoozeOptionClick={this.handleSnoozeOptionClick}
              open={dropdownOpen}
              openOnFocus={false}
              prefersOpen={prefersOpen}
            />
          }
          onClick={this.handleButtonClick}
        >
          {`${actionLabel} & ${prefersOpen ? 'Open' : 'Close'}`}
        </ButtonWithDropdown>
      </ButtonDisableWrapperStyled>
    )
  }
}

Button.propTypes = {
  /* Reply dropdown action prefix e.g. "Reply" as in "Reply & blah" */
  actionLabel: PropTypes.string.isRequired,
  /* Whether the dropdown menu is disabled */
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onSendOpenClick: PropTypes.func.isRequired,
  onSendClosedClick: PropTypes.func.isRequired,
  /* onClick handler for snooze menu options */
  onSnoozeOptionClick: PropTypes.func.isRequired,
  prefersOpen: PropTypes.bool.isRequired,
}

Button.defaultProps = {
  disabled: false,
}

export default Button
